import { ABP, eLayoutType } from '@abp/ng.core';

export const OFERTA_RECORD_BASE_ROUTES: ABP.Route[] = [
  {
    path: '/oferta-records',
    iconClass: 'fas fa-file-alt',
    name: '::Menu:OfertaRecords',
    layout: eLayoutType.application,
    requiredPolicy: 'cargo_fleet.OfertaRecords',
    breadcrumbText: '::OfertaRecords',
  },
];
